export default {
    proccess: [],
    processTable: [],
    totalFromServer: 0,
    loading: true,
    procces: {
        company: null,
        language_key: null,
        sdt_to_show: null,
        processType: null,
        isInternal: true,
        processStructureOrganized: null,
        reportType: null,
        automaticTraceability: false,
        massBalanceConfiguration: false,
        convertionFactor: null,
        printLimit: 0,
        redirectQr: null,
        isOrderType: false,
        inheritStatus: false,
        checkStock: false,
        automaticStock: true,
        appearance: {
            icon: 'mdi-sitemap',
            color: '#424242',
        },
    },
    structuresSelected: [],
    groupStructuresSelected: [],
}